import { render, staticRenderFns } from "./AtomLink.vue?vue&type=template&id=12914298&scoped=true"
import script from "./AtomLink.vue?vue&type=script&lang=ts"
export * from "./AtomLink.vue?vue&type=script&lang=ts"
import style0 from "./AtomLink.vue?vue&type=style&index=0&id=12914298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12914298",
  null
  
)

export default component.exports